module.exports = __webpack_public_path__ + "img/sample02-01.6803e45b.png";